<template>
	<div>
		<buttonlist @help="help" @exps="exps"   @save="save" ref="SetBtn"></buttonlist>
		<el-card class="box-card">
			<div style="display: flex;background: white">
				<div style="width: 50%;text-align: left;display: flex">
					<el-date-picker
					v-model="Month"
					value-format="yyyy-MM"
					type="month">
					</el-date-picker>
					<el-button type="primary" size="mini"  @click="send">{{$t('getapi[1980]')}}</el-button>
				</div>
			</div>
		</el-card> 
			<ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
			<li style="width: 100%; margin-top:0px">
			<!-- <el-table
			:data="dataSet"
			v-loading="loading"
			:highlight-current-row="true" 
			show-overflow-tooltip="true"
			border
			stripe
			size="mini"
			:height="tableHeight"
			header-row-class-name="headerclass"
			@selection-change="handleSelectionChange"
			style="width: 100%; margin-top:0px"
			>
			<el-table-column show-overflow-tooltip prop="cost_year" label="年份" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="cost_month" label="月份" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="customer_code" label="客户代码" ></el-table-column>
			<el-table-column show-overflow-tooltip prop="item_code" label="项目代码" ></el-table-column>
			<el-table-column show-overflow-tooltip prop="category_first_name" label="存货类别1" ></el-table-column>
			<el-table-column show-overflow-tooltip prop="category_second_name" label="存货类别2" ></el-table-column>
			<el-table-column show-overflow-tooltip prop="category_third_name" label="存货类别3" ></el-table-column>
			<el-table-column show-overflow-tooltip prop="part_code" label="物料编码" ></el-table-column>
			<el-table-column show-overflow-tooltip prop="part_version" label="物料版本" ></el-table-column>
			<el-table-column show-overflow-tooltip prop="part_name" label="物料名称" ></el-table-column>
			<el-table-column show-overflow-tooltip prop="sum_invoice_amount" label="主营业务收入-合计" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="inner_invoice_amount" label="主营业务收入-内销" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="outer_invoice_amount" label="主营业务收入-外销" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="sum_material_cost" label="主营业务成本(料)-合计" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="sum_man_cost" label="主营业务成本(工)-合计" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="sum_charge_cost" label="主营业务成本(费)-合计" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="inner_material_cost" label="主营业务成本(料)-内销" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="inner_man_cost" label="主营业务成本(工)-内销" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="inner_charge_cost" label="主营业务成本(费)-内销" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="outer_material_cost" label="主营业务成本(料)-外销" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="outer_man_cost" label="主营业务成本(工)-外销" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="outer_charge_cost" label="主营业务成本(费)-外销" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="sum_profit" label="主营业务毛利-合计" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="inner_profit" label="主营业务毛利-内销" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="outer_profit" label="主营业务毛利-外销" align="right"></el-table-column>
			</el-table>    -->
				<div id="xpane-0">
				<vxe-table
					:data="dataSet"
					v-loading="loading"
					border
					stripe
					resizable
					size="mini"
					:height="tableHeight"
					ref="singleTable"
				>

				<vxe-table-column show-overflow fixed="left" field="customer_code" :title="$t('getapi[4158]')"  width='100'/>
					<vxe-table-column field="Sale_Amount_Sum" :title="$t('getapi[7705]')" align="right" width='100'>
						<template slot-scope="scope">
							{{scope.row.Sale_Amount_Sum | thousandth}}
						</template>
					</vxe-table-column>
					<vxe-table-column field="Sale_Amount_Product_Sum" :title="$t('getapi[7706]')" align="right" width='100'>
						<template slot-scope="scope">
							{{scope.row.Sale_Amount_Product_Sum | thousandth}}
						</template>
					</vxe-table-column>
					<vxe-table-column field="Sale_Amount_Charge_Sum" :title="$t('getapi[7707]')" align="right" width='120'>
						<template slot-scope="scope">
							{{scope.row.Sale_Amount_Charge_Sum | thousandth}}
						</template>
					</vxe-table-column>
					<vxe-table-column field="Sale_Cost" :title="$t('getapi[7344]')" align="right" width='100'>
						<template slot-scope="scope">
							{{scope.row.Sale_Cost | thousandth}}
						</template>
					</vxe-table-column>
					<vxe-table-column field="Sale_Material_Cost" :title="$t('getapi[7708]')" align="right" width='100'>
						<template slot-scope="scope">
							{{scope.row.Sale_Material_Cost | thousandth}}
						</template>
					</vxe-table-column>
					<vxe-table-column show-overflow field="Sale_Material_Cost_Amount_Rate" :title="$t('getapi[7709]')" align="right" width='150'>
					</vxe-table-column>
					<vxe-table-column field="bom_cost" :title="$t('getapi[7710]')" align="right" width='100'>
						<template slot-scope="scope">
							{{scope.row.bom_cost | thousandth}}
						</template>
					</vxe-table-column>
					<vxe-table-column show-overflow field="BOM_Cost_Amount_Rate" :title="$t('getapi[7712]')" align="right" width='100'>
					</vxe-table-column>
					<vxe-table-column field="Sale_Man_Cost" :title="$t('getapi[7713]')" align="right" width='100'>
						<template slot-scope="scope">
							{{scope.row.Sale_Man_Cost | thousandth}}
						</template>
					</vxe-table-column>
					<vxe-table-column show-overflow field="Sale_Man_Cost_Amount_Rate" :title="$t('getapi[7711]')" align="right" width='100'></vxe-table-column>
					<vxe-table-column field="Sale_Charge_Cost" :title="$t('getapi[7714]')" align="right" width='150'>
						<template slot-scope="scope">
							{{scope.row.Sale_Charge_Cost | thousandth}}
						</template>
					</vxe-table-column>
					<vxe-table-column show-overflow field="Sale_Charge_Cost_Amount_Rate" :title="$t('getapi[7715]')" align="right" width='150'></vxe-table-column>
					<vxe-table-column field="No_Free_Arrival" :title="$t('getapi[7716]')" align="right" width='150'>
						<template slot-scope="scope">
						<el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.No_Free_Arrival"></el-input>
						</template>
					</vxe-table-column>
					<vxe-table-column field="Count_Scrap" :title="$t('getapi[7717]')" align="right" width='150'>
						<template slot-scope="scope">
						<el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.Count_Scrap"></el-input>
						</template>
					</vxe-table-column>
					<vxe-table-column field="Other_Charge_Cost" :title="$t('getapi[7718]')" align="right" width='150'>
						<template slot-scope="scope">
							{{scope.row.Other_Charge_Cost | thousandth}}
						</template>
					</vxe-table-column>
					<vxe-table-column field="Gross_Profit" :title="$t('getapi[7719]')" align="right" width='150'>
						<template slot-scope="scope">
							{{scope.row.Gross_Profit | thousandth}}
						</template>
					</vxe-table-column>
					<vxe-table-column show-overflow field="Gross_Profit_Rate" :title="$t('getapi[7720]')" align="right" width='150'/>

					<vxe-table-column field="Main_Tax_Additional" :title="$t('getapi[7721]')" align="right" width='150'>
						<template slot-scope="scope">
						<el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.Main_Tax_Additional"></el-input>
						</template>
					</vxe-table-column>
					<vxe-table-column field="Business_Expense" :title="$t('getapi[7722]')" align="right" width='150'>
						<template slot-scope="scope">
						<el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.Business_Expense"></el-input>
						</template>
					</vxe-table-column>
					<vxe-table-column field="Manage_Expense" :title="$t('getapi[6045]')" align="right" width='150'>
						<template slot-scope="scope">
						<el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.Manage_Expense"></el-input>
						</template>
					</vxe-table-column>
					<vxe-table-column field="Finance_Expense_Interet" :title="$t('getapi[7723]')" align="right" width='160'>
						<template slot-scope="scope">
						<el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.Finance_Expense_Interet"></el-input>
						</template>
					</vxe-table-column>
					<vxe-table-column field="Finance_Expense_Exchange" :title="$t('getapi[7724]')" align="right" width='150'>
						<template slot-scope="scope">
						<el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.Finance_Expense_Exchange"></el-input>
						</template>
					</vxe-table-column>
					<vxe-table-column field="Asset_Reduce" :title="$t('getapi[7725]')" align="right" width='150'>
						<template slot-scope="scope">
						<el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.Asset_Reduce"></el-input>
						</template>
					</vxe-table-column>
					<vxe-table-column field="Average_Capital_Charge" :title="$t('getapi[7726]')" align="right" width='150'>
						<template slot-scope="scope">
						<el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.Average_Capital_Charge"></el-input>
						</template>
					</vxe-table-column>
					<vxe-table-column field="OutOfBusiness_Income" :title="$t('getapi[7727]')" align="right" width='150'>
						<template slot-scope="scope">
						<el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.OutOfBusiness_Income"></el-input>
						</template>
					</vxe-table-column>
					<vxe-table-column field="OutOfBusiness_Cost" :title="$t('getapi[7728]')" align="right" width='150'>
						<template slot-scope="scope">
						<el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.OutOfBusiness_Cost"></el-input>
						</template>
					</vxe-table-column>
					<vxe-table-column field="Profit_Total" :title="$t('getapi[7729]')" align="right" width='150'>
						<template slot-scope="scope">
						<el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.Profit_Total"></el-input>
						</template>
					</vxe-table-column>



					<vxe-table-column field="Income_Tax" :title="$t('getapi[7730]')" align="right" width='150'>
						<template slot-scope="scope">
							{{scope.row.Income_Tax | thousandth}}
						</template>
					</vxe-table-column>
					<vxe-table-column field="Net_Profit" :title="$t('getapi[7731]')" align="right" width='150'>
						<template slot-scope="scope">
							{{scope.row.Net_Profit | thousandth}}
						</template>
					</vxe-table-column>
					<vxe-table-column show-overflow field="Net_Profit_Rate" :title="$t('getapi[7732]')" align="right" width='150'/>
				</vxe-table>
				</div>
			</li>
		</ul>
			<!-- <el-row>
				<el-col :span="18">
					<el-pagination
						style="margin-top: 1em"
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-sizes="[100, 200, 300, 400]"
						:page-size="100"
						:pager-count="5"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
					></el-pagination>
				</el-col>
				<el-col :span="6">
					<div style="text-align: right;line-height: 60px;color: #545c64;font-size: 95%;">表名/视图名称:{{ DbTbNames }}</div>
				</el-col>
			</el-row> -->
		<!-- </el-tabs> -->
		<serce :isVisible="isVisible" queryData="MonthSalAsCusItemPartEx" ref="ser" @getser="serclick"></serce>
		<!-- 改变表格顺序 -->
		<!-- <ctable :isVisible="false" title="CSV" queryData="SalLogicticscsvViewInfo" tabNo="0" ref="ctab" @getctab="sortclick"></ctable> -->
	
		<!-- 详情页面 -->
		<!-- <purordermanage :isVisible="isVisible" ref="order" @getdetail="getdetail"></purordermanage> -->
		<!-- 选择时间 -->
		<el-dialog v-dialogDrag :title="$t('getapi[6433]')" :visible.sync="dialogVisible" width="30%">
			<div class="bbl">
			<span>{{$t('getapi[6434]')}}</span>
			<el-date-picker v-model="copyparam.startMonth" popper-class="select-option" type="month" value-format="yyyy-MM" size="mini"></el-date-picker>
			</div>
			<div class="bbl">
			<span>{{$t('getapi[6435]')}}</span>
			<el-date-picker v-model="copyparam.copyMonth" popper-class="select-option" type="month" value-format="yyyy-MM" size="mini"></el-date-picker>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button  @click="dialogVisible = false">{{$t('getapi[6]')}}</el-button>
				<el-button type="primary" @click="copyconfirm">{{$t('getapi[1146]')}}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
	name:'3_cussalerate',
    computed: {
        tableOption() {
            return {
                border: true,
                height: this.$windowSize.tableHeight-240,
                maxHeight: this.$windowSize.tableHeight-240,
            }
        },
        tableHeight(){
            return this.$windowSize.tableHeight2
        }
    },
	data() {
		return {
			viewurl:'/CostCalc/SaleView/GetSalMaoriRateList',
			expurl:'/CostCalc/SaleView/GetSalMaoriRateListToExecl',
			Month:"",
			
			dialogVisible: false, //时间选择弹框
			dataSet: [], // 主表数据
			isVisible: false, // 查询列表是否显示
			queryData: [], // 查询数组
			userData: [], // 用户信息
			DbTbNames: '',
			pageIndex: 1, // 当前页
			pageSize: 100, // 当前页数据量
			SelectIndexs: 1, //当前页面
			total: 0, // 数据总量
			loading: false, // 主表加载状态
			isShowEdit: false, // 是否显示编辑页面
			tableHeader: [],
			dataDetail: {
				Head: {},
				Lists: []
			}, // 编辑页面数据详情
			PlanTypeArray: [], // 计划类型数组
			isEdit: true, // 是否新增操作
			selectIDList: [],
			selectObj: {
				part_code: '',
				part_version: '',
				exclusively_id: 0,
				shelflife: ''
			},
			copyparam:{
				startMonth:'',
				copyMonth:'',
			},
			btn: {
				//拷贝
				send: false,
				print:false,
				//删除
				delete: false,
			},
            scrollTop:0,
		};
	},
    watch: {
        dataSet: function () {
            let that = this
            that.$nextTick(function () {
                setTimeout(() => {
                    that.$processdata.initForm(0)
                }, 500);
            })
        },
    },
	mounted: function() {
		let that = this;
		that.userData = sessionStorage.getItem('userData');
		that.PlanTypeArray = Array.methods.getPlanType();
		that.authority();
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	methods: {
		colsort(){
			let that = this;
			that.$loadviewfields.Fileds('SalLogicticscsvViewInfo',0,PFileds=>{
			that.tableHeader=PFileds;		
		});	
		},
		sortclick(val){
			if(val==1){
				this.colsort();
			}
		},
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6629]"),this.$t("getapi[8045]"));
        },
		//type 1 一览权限 、2 编辑界面权限
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
			let limits=1;
			//that.$refs.SetBtn.SetOneBtnEnable('ctabel',true);

			//that.$refs.SetBtn.SetButtonEnable('export',true);
			that.$refs.SetBtn.SetButtonEnable('save,export');
			return;

			// //只读权
			// if (that.$limits.ReadOnlyRightsView('plv2', 375, 1, that.total)) {
			// 	if (that.total > 0) {
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
			// 	} else {
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh');
			// 	}
			// }
			// //操作权限-查询级别
			// limits = that.$limits.OperationAuthorityView('plv2', 375, 1, that.total);
			// // limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
			// switch (limits) {
			// 	case -1:
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh');
			// 		break;
			// 	case 1:
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
			// 		break;
			// 	case -2:
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh');
			// 		break;
			// 	case 2:
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
			// 		break;
			// 	case -3:
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh');
			// 		break;
			// 	case 3:
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
			// 		break;
			// 	default:
			// 		break;
			// }
			// if(limits==-1||limits==1)that.closeAllRightButton();
            // else that.btnauthority();
		},
		btnauthority() {
			let that = this;
			that.btn.send = false;
			that.btn.delete = false;
			that.btn.print = false;
			
		},
		closeAllRightButton(){
			let that =this;
			that.btn.send = false;
			that.btn.delete = false;
			that.btn.print = false;
		},
		changeperiod() {
			let that = this;
			that.$http.urlpost('/Inv/Manager/InvInfoUpdateShelflife', that.selectObj, function(res) {
				if (res.Success == 1) {
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
					that.getView();
				}
				that.dialogVisible = false;
			});
		},
		showdialog() {
			let that = this;
			if (that.selectObj.exclusively_id == 0) {
				that.$message.warning(that.$t('getapi[8623]'));//'请选择一项！'
				return;
			}
			that.dialogVisible = true;
		},
		handleSelectionChange(val) {
		let that = this;
		that.selectIDList=val;
		if(that.selectIDList.length>0){
			that.btn.send = true;
			that.btn.delete = true;
			that.btn.print = true;
		}else{
			that.btn.send = false;
			that.btn.delete = false;
			that.btn.print = false;
		}
		},
		
		handleSizeChange(val) {
			this.pageSize = val;
			this.getView();
			this.authority();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getView();
			this.authority();
		},
		// 查询
		search() {
			let that = this;
			that.isVisible = true;
			that.pageIndex=1;
			that.$refs.ser.clearInput(that.isVisible, 'MonthSalAsCusItemPartEx');
		},
		// 修改表格顺序
		opentable(){
			this.$refs.ctab.clearInputs(true);
		},
		//获取查询条件
		serclick(val) {
			this.queryData = val;
			this.confirmGetView();
		},
		// 确认获取数据
		confirmGetView() {
			let that = this;
			that.isVisible = false;
			that.getView();
		},
		// 数据一览
		getView() {
			let that = this;
			that.loading = true;
			
			that.$http.urlpost(that.viewurl, that.datac, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
					that.total = res.Totals;
					that.loading = false;
					that.DbTbNames = res.DbTbNames;
				}
				that.authority();
			});
		},
		// 根据ID获取详情数据
		editInfo(row) {
			let that = this;
			that.isShowEdit = true;
			that.isEdit = true;
			let parm = {
				Code: row.PO_Code,
				List: []
			};
			this.$refs.order.clearInput(this.isShowEdit, parm);
		},
		// 新增
		add() {
			let that = this;
			let datetime = Common.methods.getDatetime()
			that.isEdit = false;
			that.isShowEdit = true;
			that.dataDetail = {
				Head: {},
				Lists: []
			};
		},
		// 刷新
		reflash() {
			let that = this;
			that.getView();
		},
		//按月拷贝成本
		copy(){
			let that = this;
			that.dialogVisible = true;
			
		},
		copyconfirm(){
			//  
			let that = this;
			that.btn.copy = false
			let parm = {
			"newmonth": that.copyparam.copyMonth.split("-")[1],
			"newyear": that.copyparam.copyMonth.split("-")[0],
			"oldmonth": that.copyparam.startMonth.split("-")[1],
			"oldyear": that.copyparam.startMonth.split("-")[0],
			}

			that.$http.urlpost('/Inv/PartCost/InvPartStdCostCopyCost', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(Common.SuccessMsg);
				}
				that.btn.copy = true;
				that.dialogVisible = false;
			});


		},
		send(){
			let that = this;
			
			if(that.$limits.fnIsEmpty(that.Month))
			{
				that.$message.warning(that.$t('getapi[6086]'));//"请选择日期"
				return;
			}
			let datac ={
			TYear: that.Month.split('-')[0],
			Month:  that.Month.split('-')[1],
			};
			that.loading = true;
			//console.log(datac)
			that.$http.urlpost(that.viewurl, datac, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
				}
				that.loading = false;
			});
		},
		print(){
			let that = this;
			let parm = {
			po_no: '',
			TemplateName: '08Invoice_CSV.xlsx'
			};

			for(let i=0;i<that.selectIDList.length;i++){
			parm.po_no= parm.po_no + "'"+that.selectIDList[i].exclusively_id+"',";
			}
			parm.po_no =  parm.po_no.substring(0, parm.po_no.length - 1);

			that.btn.print = false;
			that.loading = true;
			that.$http.urlpost('/Print/CSVPrint', parm, function (res) {
			that.btn.print = true;
			if (res.Success == 1) {
			let hrefurl = res.Key;
			window.open(hrefurl);
			} 
			that.loading = false;
			});
		},
		deleteline(){
			let that = this;
			let parm = {
				Delivery_Note_N: that.selectIDList[0].Delivery_Note_N,
			};
			that.$http.urlpost('/Sal/Tru/DeleteCsv', parm, function(res) {
				if (res.Success == 1) {
					that.reflash();
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
				}
			});

		},
		// 导出
		exps() {
			let that = this;
			that.loading = true;
			if(that.$limits.fnIsEmpty(that.Month))
			{
				that.$message.warning(that.$t('getapi[6086]'));//"请选择日期"
				return;
			}
			let datac ={
			TYear: that.Month.split('-')[0],
			Month:  that.Month.split('-')[1],
			};
			that.$http.urlpost(that.expurl, datac, function(res) {
				if (res.Success == 1) {
					let hrefurl = Common.Url + res.DataContent.URL;
					window.open(hrefurl);
				}
				that.loading = false;
			});
		},
		// 保存
		save() {
			let that = this;
			if(that.$limits.fnIsEmpty(that.Month))
			{
				that.$message.warning(that.$t('getapi[6086]'));//"请选择日期"
				return;
			}
			let parm = {
				dt: that.dataSet,
				P: {
					TYear: that.Month.split('-')[0],
					Month:  that.Month.split('-')[1],
				}
			}
			that.loading = true;
			that.$http.urlpost('/CostCalc/SaleView/SaveSalMaoriRate', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(Common.SuccessMsg);
				}
				that.loading = false;
			});
		},
		//
		editInfo1() {},
		editInfo2() {},
		editInfo3() {}
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}

.bbl {
	margin: 0px auto 10px;
	white-space: pre;
	span {
		margin-left: 10px;
		min-width: 70px;
		text-align: left;
		line-height: 20px;
		display: inline-block;
		margin-right: 0px;
	}
}
</style>
